export const getAuthUrl = () => {
  const authUrl = process.env.REACT_APP_AUTH_API_URL;
  return authUrl?.endsWith("/") ? authUrl : `${authUrl}/`;
};

export const getAuthRedirectUrl = () => {
  let domain = "";
  const location = new URL(window.location.href);
  const divisions = location.hostname.split(".");
  if (divisions.length === 4) {
    domain = divisions.shift() || "";
    location.hostname = divisions.join(".");
  }

  const targetUrl = `${getAuthUrl()}logout`;
  const pathBuilder = new URL(targetUrl);

  // Check for bypass_sso query parameter and add it if present
  const bypassSso = new URLSearchParams(window.location.search).get(
    "bypass_sso"
  );
  if (bypassSso) {
    pathBuilder.searchParams.append("bypass_sso", bypassSso);
  }

  pathBuilder.searchParams.append("referrer", location.href);
  if (domain) pathBuilder.searchParams.append("domain", domain);

  return pathBuilder;
};
